import styled from 'styled-components';
import colors from '../../../../includes/colors';

export const Tabs = styled.div`
  display: flex;
  height: 60px;
  margin-bottom: 30px;
`;

export const Tab = styled.button`
  width: 100%;
  background-image: linear-gradient(180deg, #fff, #f0f0f0);
  border: 1px solid #d6d6d6;
  color: ${colors.paleBlue};
  font-size: 15px;

  &:hover {
    background-color: #cce5f1;
    background-image: none;
    text-decoration: none;
  }

  &:focus {
    outline: none;
  }

  &.active {
    background-color: black;
    background-image: none;
    background-color: #fff;
    border-top-width: 3px;
    border-top-color: #007db8;
    border-bottom-width: 0px;
  }
`;
